import { render } from "./ProductRegistrationConfirmation.vue?vue&type=template&id=cad42244"
import script from "./ProductRegistrationConfirmation.vue?vue&type=script&lang=js"
export * from "./ProductRegistrationConfirmation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__